import styled, { css } from 'styled-components'

export const Wrapper = styled.div``

export const BackgroundImageWrapper = styled.div`
    border-radius: 10px;
    height: 352px;
    position: relative;
    overflow: hidden;
    margin-bottom: 30px;

    &:after {
        content: '';
        width: 100%;
        height: 100%;
        position: absolute;
        /*! @noflip */
        background: linear-gradient(359.53deg, #000000 19.14%, rgba(0, 0, 0, 0) 41.15%);
        opacity: 0.7;
        top: 0px;
    }
`

export const Title = styled.h3`
    color: ${(props) => props.theme.color.white};
    ${(props) => props.theme.typo.displayM}
    ${(props) => props.theme.fontWeight.bold}
    position:absolute;
    bottom: 30px;
    left: 30px;
    z-index: 1;
`

export const Row = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 16px;
    &:last-child {
        margin-bottom: 0;
    }

    @media ${(props) => props.theme.query.min.tablet} {
        margin-bottom: 25px;
    }
`

export const IconWrapper = styled.div`
    margin-right: 10px;
`

const descriptionStyle = css`
    ${(props) => props.theme.typo.bodyM}
    ${(props) => props.theme.fontWeight.medium}
    color: ${(props) => props.theme.color.g600};
    text-decoration: none;
`

export const Description = styled.p`
    ${descriptionStyle}
`

export const HelperText = styled.span`
    ${(props) => props.theme.typo.bodyS}
    ${(props) => props.theme.fontWeight.regular};
    color: ${(props) => props.theme.color.g500};
    font-style: italic;
    display: block;
    margin-top: 2px;
`
